import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AtividadeEconomicaService } from '../../../../services/configuracoes/atividade-economica.service';
import { AtividadeEconomicaDTO } from '../../../../models/configuracoes/atividade-economica.model';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

interface atividadesList extends AtividadeEconomicaDTO {
  label: string;
  value: string;
}

@Component({
  selector: 'app-atividade-economica-add',
  templateUrl: './atividade-economica-add.component.html',
  styleUrl: './atividade-economica-add.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class AtividadeEconomicaAddComponent {
  atividades: AtividadeEconomicaDTO[] = [];
  atividadesList: atividadesList[] = [];
  atividadesTable: AtividadeEconomicaDTO[] = [];
  selectedAtividade: atividadesList = {} as atividadesList;

  @Input() visible: boolean = false;
  @Input() isDialog: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Output() atividadesEconomicas = new EventEmitter<AtividadeEconomicaDTO[]>();
  @Input() atividadesEconomicasList: AtividadeEconomicaDTO[] = [];

  constructor(private atividadeService: AtividadeEconomicaService) {}

  ngOnInit() {
    this.findAtividadeEconomica();
  }

  ngOnChanges() {
    this.atividadesTable = this.atividadesEconomicasList;
  }

  findAtividadeEconomica(): Promise<void> {
    return new Promise((resolve) => {
      this.atividadeService
        .get('/atividadeEconomica?listarTodos=true')
        .subscribe((response) => {
          this.atividades = response.content;

          this.atividadesList = this.atividades.map((atividade) => ({
            ...atividade,
            label: `${atividade.codigo} - ${atividade.nome}`,
            value: String(atividade.id),
          }));
          resolve();
        });
    });
  }

  deleteAtividade(id: string) {
    const index = this.atividadesTable.findIndex(
      (atividade) => String(atividade.id) === String(id)
    );
    if (index !== -1) {
      this.atividadesTable.splice(index, 1);
      this.atividadesEconomicas.emit(this.atividadesTable);
    }
  }

  addAtividade() {
    const existe = this.atividadesTable.some(
      (atividade) => atividade.id === this.selectedAtividade.id
    );
    if (existe) {
      return;
    }
    this.atividadesTable.push(this.selectedAtividade);
    this.selectedAtividade = {} as atividadesList;
    this.atividadesEconomicas.emit(this.atividadesTable);
  }

  saveDialog() {
    const sendAtividades = this.atividadesTable;
    this.atividadesTable = [];
    this.selectedAtividade = {} as atividadesList;
    this.atividadesEconomicas.emit(sendAtividades);
  }

  closeDialog() {
    this.atividadesTable = [];
    this.selectedAtividade = {} as atividadesList;
    this.visibleChange.emit(false);
  }

  showDialog() {
    this.visibleChange.emit(true);
  }

  deletarAtividadeEconomica(id: string) {}
}
